import withBookingAdminContext from "../withBookingAdminContext";
import { FlightSelectorLCPage } from "../pages/Modification";
export default withBookingAdminContext(FlightSelectorLCPage);